module.exports = __webpack_public_path__ + "static/media/coin-spin.2fb1222c.gif";